<form [formGroup]="profileForm" (ngSubmit)="onSubmit(false, true)" class="was-validated">
  <div kendoWindowContainer></div>
  <div kendoDialogContainer></div>
  <div class="flex items-center mb-2">
<!--     <a *ngIf="showAccountFiles" (click)="viewFilestransaction()" routerLinkActive="router-link-active">
      <ng-icon name="heroFolder" style="font-size: 15px" title="View Files"></ng-icon>
      <span style="font-size: small; cursor: pointer">
        View Files for this Transaction
      </span>
    </a> -->
    <a *ngIf="showAccountFiles" (click)="viewFilesaccount()" routerLinkActive="router-link-active">
      <ng-icon name="heroFolder" style="font-size: 15px" title="View Files"></ng-icon>
      <span style="font-size: small; cursor: pointer">
        View Files for this Account
      </span>
    </a>
    <!-- ml-5 is 20px of clearance from the files link. It is on the button rather
         than a gap on the row so the button still sits flush left when that link
         is not rendered (the two have independent *ngIf conditions). -->
    <button *ngIf="returnTransactionUrl" type="button" (click)="returnToTransaction()"
      class="ml-5 px-3 py-1.5 text-sm font-medium text-blue-600 dark:text-blue-400
             border border-blue-600 dark:border-blue-400
             rounded-md hover:bg-blue-50 dark:hover:bg-blue-900
             focus:outline-none focus:ring-2 focus:ring-blue-300
             transition-colors duration-200">
      &larr; Back to Transaction
    </button>
  </div>
  <kendo-window *ngIf="showtaxinfo" [draggable]="true" (close)="openClose()" [title]="headtitlePopup">
    <div class="inner-wrapper" *ngFor="let t of taxList">
      <a (click)="FilterAddAccountScreen(t.taxID, t.lastName)" routerLinkActive="router-link-active"><strong>First
          Name:</strong> &nbsp;{{ t.firstName }}&nbsp;&nbsp;
        <strong>Last Name:</strong> &nbsp;{{ t.lastName }}
        <strong> Account Name:</strong> &nbsp;{{ t.accountName }}&nbsp;&nbsp;
        <strong>Last 4:</strong> &nbsp;{{ t.taxID }}&nbsp;&nbsp;
      </a>
    </div>
  </kendo-window>
  <div class="grid grid-cols-1 lg:grid-cols-2 gap-x-4 gap-y-[5px]">
    <!-- ###################################### Card 1 $$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$   -->
    <div class="card w-full" [@simpleFadeAnimation]="'in'" style="height: auto  !important; ">
      <div class="card-header flex justify-between items-center cursor-pointer" (click)="toggleAccountInfo()">
        <div class="flex items-center gap-2">
          <ng-icon [name]="accountInfoExpanded ? 'heroChevronDown' : 'heroChevronRight'"
            class="text-gray-600"></ng-icon>
          <h3 class="card-title">Account Information</h3>
          <span style="color: red" *ngIf="profileForm.get('AccountOpen')?.value === false">
            - Account has been closed</span>
        </div>
        <span *ngIf="!profileForm.get('AccountOpen')?.value" class="text-danger-600 font-semibold">Closed</span>
      </div>
      <div class="p-6 space-y-4" *ngIf="accountInfoExpanded">
        <!-- Rep Selection -->
        <div *ngIf="Rolerep" class="flex items-center gap-2">
          <ng-icon name="heroUser" class="text-gray-400"
            [ngClass]="{ 'text-red-500': style0, 'text-green-500': style00 }"></ng-icon>
          <span class="font-medium text-[10px] whitespace-nowrap mr-2">REP:</span>
          <kendo-combobox #combo (focus)="onFocus(combo)" [suggest]="true" [virtual]="virtual" [loading]="loader"
            formControlName="RepId" [valuePrimitive]="true" [data]="listItems" textField="lastName" valueField="repId"
            placeholder="Select Rep..." required class="w-full max-w-md" />
        </div>
        <!-- Advisor Client Radio -->
        <div *ngIf="advisorrole" class="flex items-center gap-2">
          <ng-icon name="heroExclamationCircle" class="text-gray-400"
            [ngClass]="{ 'text-red-500': advisebool, 'text-green-500': adviseboolvalue }"></ng-icon>
          <span class="font-medium text-[10px] whitespace-nowrap mr-2">Advisor Client:</span>
          <div class="flex items-center gap-2">
            <label class="flex items-center gap-1">
              <input type="radio" formControlName="AdvisorClient" value="true" kendoRadioButton />
              <span class="text-[10px]">Yes</span>
            </label>
            <label class="flex items-center gap-1">
              <input type="radio" formControlName="AdvisorClient" value="false" kendoRadioButton />
              <span class="text-[10px]">No</span>
            </label>
          </div>
        </div>
        <!-- Client Type Dropdown -->
        <!-- Account Type row -->
        <div class="flex items-center gap-2">
          <ng-icon name="heroDocumentText" class="text-gray-400"
            [ngClass]="{ 'text-red-500': style5, 'text-green-500': style6 }"></ng-icon>
          <span class="font-medium text-[10px] whitespace-nowrap">Account Type</span>
          <kendo-dropdownlist formControlName="ClientTypeId" [valuePrimitive]="true" [data]="listClientTypes"
            textField="clientTypeDesc" valueField="clientTypeId" (selectionChange)="selectionChange($event)"
            style="width: 250px" required />
        </div>

        <!-- Advisor Client radio group over Account Name (shows only if advisorrole) -->
        <!--         <div>
          <div *ngIf="advisorrole" class="flex items-center gap-1">
            <ng-icon name="heroExclamationCircle" class="text-gray-400"
              [ngClass]="{ 'text-red-500': advisebool, 'text-green-500': adviseboolvalue }"></ng-icon>
            <span class="font-medium text-[10px] whitespace-nowrap mr-1">Advisor Client:</span>
            <label class="flex items-center gap-1">
              <input type="radio" formControlName="AdvisorClient" value="true" kendoRadioButton />
              <span class="text-[10px]">Yes</span>
            </label>
            <label class="flex items-center gap-1">
              <input type="radio" formControlName="AdvisorClient" value="false" kendoRadioButton />
              <span class="text-[10px]">No</span>
            </label>
          </div>
        </div> -->
        <!-- Account Name row -->
        <div class="flex items-center gap-2">
          <!-- Left: Icon and label column -->
          <ng-icon name="heroPencilSquare" class="text-gray-400"
            [ngClass]="{ 'text-red-500': style1, 'text-green-500': style2 }"></ng-icon>
          <span class="font-medium text-[10px] whitespace-nowrap">Account Name</span>

          <!-- Right: label (if any) and input, stacked vertically -->
          <div class="flex flex-col flex-1">
            <kendo-label *ngIf="displaytext" [innerHtml]="displaytext"
              class="text-[10px] font-medium text-red-500 mb-0.5"></kendo-label>
            <input kendoTextBox type="text" formControlName="AccountName" required class="w-full max-w-md" />
          </div>
        </div>

        <!-- Tax ID -->
        <div class="flex items-center gap-2">
          <ng-icon name="heroIdentification" class="text-gray-400"
            [ngClass]="{ 'text-red-500': style3, 'text-green-500': style4 }"></ng-icon>
          <span class="font-medium text-[10px] whitespace-nowrap">Tax ID</span>
          <kendo-maskedtextbox #maskvalue [mask]="mask" formControlName="TaxId" (blur)="detectchange2(maskvalue)"
            class="w-full max-w-md" />
        </div>
        <div>
          <span class="blink_textno" *ngIf="TxIdExist && !isSoftDupType()">*Tax Id and Account Type exists you cannot continue.
            Please
            go to view accounts.</span>
          <!-- 529 / UTMA-UGMA: soft warning only, saving is still allowed -->
          <div *ngIf="isSoftDupType() && primaryDupMatches.length"
            class="mt-1 rounded-md border border-warning bg-warning-light p-2 text-[11px] text-gray-800" role="status">
            <div class="font-semibold">&#9888; An account with this Tax ID already exists. You can still save.</div>
            <ul class="mt-1 list-none pl-0">
              <li *ngFor="let m of primaryDupMatches">
                <a class="text-primary underline cursor-pointer" (click)="openExistingAccount(m.clientID)"
                  title="Opens the existing account in a new tab">{{ m.accountName || (m.lastName + ', ' + m.firstName) }}</a>
                <span class="text-gray-600"> &middot; {{ accountTypeLabel(m.clientTypeId) }}<span *ngIf="m.taxID"> &middot; &bull;&bull;{{ m.taxID }}</span></span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- Card 2 -->
    <div class="card w-full lg:w-[48%]" [@simpleFadeAnimation]="'in'" style="height:auto !important;line-height: 19px;" *ngIf="!advisorrole">
      <div class="card-header flex justify-between items-center">
        <h3 class="card-title">Investment Information</h3>
        <span *ngIf="!profileForm.get('AccountOpen')?.value" class="text-danger-600 font-semibold">Closed</span>
      </div>
      <div class="p-6 space-y-4">
        <div class="Accountwrapper">
          <label class="tiny">
            <ng-icon name="heroCurrencyDollar" [ngClass]="{
                      novalue: annualbool === true,
                      havevalue: annualboolvalue === true
                    }"></ng-icon>
            Annual Income From:
          </label>
          <kendo-numerictextbox #annualIncFrom [value]="numValue" [min]="0" [format]="'0'" [spinners]="false"
            formControlName="AnnualIncFrom" AllowRounding="True" required [autoCorrect]="autoCorrect"
            (ngModelChange)="checkValueGreater('AnnualInc')"></kendo-numerictextbox>
          <span class="tiny" style="margin: 0px 20px 0px 20px">To:</span>
          <kendo-numerictextbox [format]="'0'" [min]="0" [spinners]="false" formControlName="AnnualIncTo" required
            [autoCorrect]="autoCorrect" (ngModelChange)="checkValueGreater('AnnualInc')"></kendo-numerictextbox>
          <span class="msg" *ngIf="showmessage0">To must be Greater than From</span>
          <!-- Net Worth -->
          <div class="spacing">
            <label class="tiny">
              <i class="fas fa-hand-holding-usd" [ngClass]="{
                        novalue: networthbool === true,
                        havevalue: networthboolvalue === true
                      }"></i>
              Net Worth From:
            </label>
            <kendo-numerictextbox [value]="numValue" [min]="0" [format]="'0'" [spinners]="false"
              formControlName="NetWorthFrom" AllowRounding="True" required [autoCorrect]="autoCorrect"
              (ngModelChange)="checkValueGreater('NetWorth')"></kendo-numerictextbox>
            <span class="tiny" style="margin: 0px 20px 0px 20px">To:</span>
            <kendo-numerictextbox [format]="'0'" [min]="0" [spinners]="false" formControlName="NetWorthTo" required
              AllowRounding="True" [autoCorrect]="autoCorrect"
              (ngModelChange)="checkValueGreater('NetWorth')"></kendo-numerictextbox>
            <span *ngIf="showmessage1" class="msg">To must be Greater than From</span>
          </div>

          <!-- Liquid Net Worth -->
          <div class="spacing">
            <label class="tiny">
              <i class="fas fa-hand-holding-usd" [ngClass]="{
                        novalue: Liquidbool === true,
                        havevalue: Liquidboolvalue === true
                      }"></i>
              Liquid Net Worth From:
            </label>
            <kendo-numerictextbox [value]="numValue" [min]="0" [format]="'0'" [spinners]="false"
              formControlName="LiquidNWFrom" AllowRounding="True" required [autoCorrect]="autoCorrect"
              (ngModelChange)="checkValueGreater('LiquidNW')"></kendo-numerictextbox>
            <span class="tiny" style="margin: 0px 20px 0px 20px">To:</span>
            <kendo-numerictextbox [format]="'0'" [min]="0" [spinners]="false" formControlName="LiquidNWTo" required
              AllowRounding="True" [autoCorrect]="autoCorrect"
              (ngModelChange)="checkValueGreater('LiquidNW')"></kendo-numerictextbox>
            <span class="msg" *ngIf="showmessage2">To must be Greater than From</span>
          </div>

          <!-- Risk Exposure -->
          <div class="spacing">
            <label class="tiny">
              <i class="fas fa-asterisk" [ngClass]="{
                        novalue: riskbool === true,
                        havevalue: riskvalue === true
                      }"></i>
              Risk Exposure:
            </label>
            <kendo-dropdownlist #drop formControlName="InvestmentProfileId" [textField]="'profileDescription'"
              [valueField]="'investmentProfileId'" [valuePrimitive]="true" required [virtual]="virtual"
              [loading]="investloading" [data]="InvestObjLists" style="width: 350px"></kendo-dropdownlist>
          </div>
          <!-- Investment Objective -->
          <div class="spacing">
            <label class="tiny">
              <i class="fas fa-asterisk" [ngClass]="{
                        novalue: investbool === true,
                        havevalue: investvalue === true
                      }"></i>
              Investment Objective:
            </label>
            <kendo-dropdownlist #drop formControlName="InvObjectiveId" [textField]="'description'"
              [valuePrimitive]="true" required [valueField]="'invesmentObjectiveId'" [virtual]="virtual"
              [loading]="investobjloading" [data]="InvestObjnwewLists" style="width: 350px"></kendo-dropdownlist>
          </div>
          <!-- Liquidity Needs -->
          <div class="spacing">
            <label class="tiny">
              <i class="fas fa-asterisk" [ngClass]="{
                        novalue: liquiddropbool === true,
                        havevalue: liquiddropvalue === true
                      }"></i>
              Liquidity Needs:
            </label>
            <kendo-dropdownlist #drop formControlName="LiquidityNeedsId" [textField]="'description'"
              [valuePrimitive]="true" required [valueField]="'liquidityNeedsId'" [virtual]="virtual"
              [loading]="liqquidloading" [data]="LiquidityNeedsLists" style="width: 350px"></kendo-dropdownlist>
          </div>
           <div class="spacing">
            <label class="tiny">
              <i class="fas fa-asterisk" [ngClass]="{
                        novalue: timehorizonbool === true,
                        havevalue: timehorizonboolvalue === true
                      }"></i>
             Time Horizon:
            </label>
            <kendo-dropdownlist #drop formControlName="InvestmentTimeHorizonId" [textField]="'lengthOfTime'"
              [valuePrimitive]="true" required [valueField]="'invesmentTimeHorizonId'" [virtual]="virtual"
              [loading]="timezoneloading" [data]="TimeHorizonLists" style="width: 350px"></kendo-dropdownlist>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- ROW 2: Cards 3 & 4 -->
  <div>&nbsp;</div>
  <div class="grid grid-cols-1 lg:grid-cols-2 gap-x-4 gap-y-[5px]">
    <!-- Card 3 -->
    <div class="card w-full lg:w-[48%]" [@simpleFadeAnimation]="'in'"
      style="height:auto !important; margin-top:0px; line-height: 15px;">
      <div class="card-header flex justify-between items-center">
        <h3 class="card-title">{{ HeaderInfo }}</h3>
      </div>
      <div class="p-6 space-y-4">
        <div *ngIf="hideclientreplist">
          <label class="tiny">If a client exists simply select the client below:</label>
          <kendo-combobox #combo2 (selectionChange)="selectclientbyClientId($event)" [virtual]="virtual"
            [loading]="loader" style="width: 300px; margin-left: 8px; margin-bottom: 10px" [popupSettings]="{ width: '550px' }"
            [kendoDropDownFilter]="filterSettings" [valuePrimitive]="true" [data]="clientlisting"
            [textField]="'firstName'" [valueField]="'clientId'">
            <ng-template kendoComboBoxItemTemplate let-dataItem>
              <span class="text-xs">{{ dataItem.firstName }}</span>
            </ng-template>
          </kendo-combobox>
        </div>
        <div>
          <label class="tiny">
            <i class="fas fa-hand-point-up" [ngClass]="{
                      novalue: fname === true,
                      havevalue: fnamevalue === true
                    }"></i>&nbsp;{{ FirstNamecompany }} </label>&nbsp;&nbsp;<input kendoTextBox type="text" #first
            formControlName="FirstName" required class="form-control" />
        </div>
        <div class="spacing" *ngIf="!displayInfo">
          <label class="tiny"> Middle Name: </label>&nbsp;&nbsp;<input kendoTextBox type="text"
            formControlName="MiddleName" />
        </div>
        <div class="spacing" *ngIf="!displayInfo">
          <label class="tiny">
            <i class="far fa-hand-point-right" [ngClass]="{
                      novalue: lname === true,
                      havevalue: lnamevalue === true
                    }"></i>&nbsp;Last Name: </label>&nbsp;&nbsp;<input kendoTextBox type="text" #last
            formControlName="LastName" required class="form-control" />
        </div>
        <div class="spacing" *ngIf="RoleAdvisor">
          <label class="tiny">
            <i class="far fa-calendar-check" [ngClass]="{
                      novalue: dobbool === true,
                      havevalue: dobboolvalue === true
                    }"></i>&nbsp; Date of Birth:&nbsp; </label>&nbsp;&nbsp;<kendo-datepicker #dp0 style="width: 200px"
            activeView="year" placeholder="01/05/2000" [focusedDate]="focusedDOBDate" (focus)="onFocus0(dp0)"
            formControlName="DOB" [disabledDates]="accountDateDisabledDates" (valueChange)="calculatePrimaryAge($event)"
            #dob>
          </kendo-datepicker>&nbsp;
          <label class="tiny">
            {{ calculatedPrimaryAge }}
          </label>
        </div>
        <div class="spacing" *ngIf="RoleAdvisor">
          <label class="tiny">
            <i class="fas fa-asterisk" [ngClass]="{
                      novalue: addrbool === true,
                      havevalue: addrboolvalue === true
                    }"></i>&nbsp;Address 1: </label>&nbsp;&nbsp;<input #addr kendoTextBox type="text"
            formControlName="Address1" required class="form-control" />
        </div>
        <div class="spacing" *ngIf="RoleAdvisor">
          <label class="tiny"> &nbsp;Address 2: </label>&nbsp;&nbsp;<input kendoTextBox type="text"
            formControlName="Address2" />
        </div>
        <div class="spacing" *ngIf="RoleAdvisor">
          <label class="tiny">
            <i class="fas fa-city" [ngClass]="{
                      novalue: ctybool === true,
                      havevalue: ctyboolvalue === true
                    }"></i>&nbsp;City: </label>&nbsp;&nbsp;<input #cty kendoTextBox type="text" formControlName="City"
            required class="form-control" />
        </div>
        <div class="spacing" *ngIf="RoleAdvisor">
          <label class="tiny">
            <i class="fas fa-flag-usa" [ngClass]="{
                      novalue: statebool === true,
                      havevalue: statevalue === true
                    }"></i>&nbsp;State: </label>&nbsp;&nbsp;
          <kendo-dropdownlist #state formControlName="State" [textField]="'stateText'" [valuePrimitive]="true"
            [valueField]="'stateValue'" [virtual]="virtual" [data]="listStates" style="width: 250px">
          </kendo-dropdownlist>
        </div>
        <div class="spacing" *ngIf="RoleAdvisor">
          <label class="tiny">
            <i class="fas fa-map-marker-alt" [ngClass]="{
                      novalue: zipbool === true,
                      havevalue: zipvalue === true
                    }"></i>&nbsp;ZipCode: </label>&nbsp;&nbsp;<kendo-maskedtextbox [mask]="zipcodestring" required
            [maskValidation]="maskValidation" #zip formControlName="ZipCode" class="form-control">
          </kendo-maskedtextbox>
          <!--     <span style="font-size:10px;"><i class="fas fa-search"></i><a (click)="Lookuprecord()">Look
                    up</a></span> -->
        </div>
        <div class="spacing" *ngIf="RoleAdvisor">
          <label class="tiny"><i class="fas fa-asterisk" [ngClass]="{
                      novalue: profileForm.get('ClientTypeId')?.value !== 5 && !profileForm.get('EmailAddress')?.value,
                      havevalue: profileForm.get('ClientTypeId')?.value === 5 || profileForm.get('EmailAddress')?.value
                    }"></i>&nbsp; Email: </label>&nbsp;&nbsp;<input kendoTextBox type="email"
            formControlName="EmailAddress" [required]="profileForm.get('ClientTypeId')?.value !== 5" />
        </div>
        <div class="spacing" *ngIf="RoleAdvisor">
          <label class="tiny"> Mobile/Phone: </label>&nbsp;&nbsp;<kendo-maskedtextbox [mask]="mobileMask"
            formControlName="Mobile" [promptPlaceholder]="' '"></kendo-maskedtextbox>
        </div>
        <div class="spacing" *ngIf="RoleAdvisor">
          <label class="tiny"> Associated Person: </label>&nbsp;&nbsp;<input kendoTextBox type="text"
            formControlName="AssociatedPerson" />
        </div>
        <div class="spacing" *ngIf="RoleAdvisor">
          <label class="tiny"> Association to Account: </label>&nbsp;&nbsp;<input kendoTextBox type="text"
            formControlName="AssociatedAccount" />
        </div>
        <div class="spacing" *ngIf="RoleAdvisor">
          <label class="tiny"> Account Active: </label>&nbsp;&nbsp;<input #AccountOpen formControlName="AccountOpen"
            *ngIf="profileForm.get('AccountOpen')?.value === true" (click)="onDelete()" type="checkbox"
            style="width: 1.5em" kendoCheckBox />
          <input #AccountOpen formControlName="AccountOpen" *ngIf="profileForm.get('AccountOpen')?.value === false"
            (click)="onOpen()" type="checkbox" style="width: 1.5em" kendoCheckBox />
        </div>
        <div class="spacing" *ngIf="RoleAdvisor">
          <label class="tiny"> Copy of DL: </label>&nbsp;&nbsp;<kendo-dropdownlist formControlName="CopyOfDl"
            [data]="SeletedList" style="width: 350px">
          </kendo-dropdownlist>
        </div>
        <div class="spacing" *ngIf="RoleAdvisor">
          <label class="tiny"> Account Form: </label>&nbsp;&nbsp;<kendo-dropdownlist formControlName="NewAccountForm"
            [data]="SeletedList" style="width: 350px">
          </kendo-dropdownlist>
        </div>
        <div class="spacing" *ngIf="RoleAdvisor">
          <label class="tiny">
            <i class="far fa-calendar-check" [ngClass]="{
                      novalue: dtebool === true,
                      havevalue: dtevalue === true
                    }"></i>&nbsp; </label>&nbsp;<kendo-datepicker #dp1 (focus)="onFocus1(dp1)"
            (blur)="onDateFormBlur()"
            style="width: 200px" [focusedDate]="focusedDateAccountform" formControlName="DateOfNewAccountForm"
            [disabledDates]="accountDateDisabledDates">
          </kendo-datepicker>
        </div>
      </div>
    </div>
    <!-- Card 4 -->
    <div class="card w-full lg:w-[48%]" [@simpleFadeAnimation]="'in'" style="height:auto !important">
      <div class="card-header flex justify-between items-center">
        <h3 class="card-title">Investment Experience (since year)</h3>
      </div>
      <div style="padding:10px !important">
        <div class="Accountwrapper">
          <label class="tiny">
            &nbsp;Equities: <span class="yearright">Year:</span> </label>&nbsp;&nbsp;
          <kendo-numerictextbox [autoCorrect]="autoCorrect" [format]="'0'" [spinners]="false"
            formControlName="EquitiesExp" [min]="investmin" [max]="investmax" [value]="numValue">
          </kendo-numerictextbox>
          <span class="tiny" style="margin: 0px 20px 0px 20px">Options:</span>
          <span class="tiny" style="margin: 0px 10px 0px 70px">Year:</span>
          <kendo-numerictextbox [autoCorrect]="autoCorrect" [format]="'0'" [spinners]="false"
            formControlName="OptionsExp" [min]="investmin" [max]="investmax" [value]="numValue">
          </kendo-numerictextbox>
          <div class="spacing">
            <label class="tiny">
              &nbsp;Fixed Income:
              <span class="yearright">Year:</span> </label>&nbsp;&nbsp;
            <kendo-numerictextbox [autoCorrect]="autoCorrect" [format]="'0'" [spinners]="false"
              formControlName="FixedIncExp" [min]="investmin" [max]="investmax" [value]="numValue">
            </kendo-numerictextbox>
            <span class="tiny" style="margin: 0px 20px 0px 20px">Mutual funds:</span>
            <span class="tiny" style="margin: 0px 10px 0px 42px">Year:</span>
            <kendo-numerictextbox [autoCorrect]="autoCorrect" [format]="'0'" [spinners]="false"
              formControlName="MutFundsExp" [min]="investmin" [max]="investmax" [value]="numValue">
            </kendo-numerictextbox>
          </div>
          <div class="spacing">
            <label class="tiny">
              &nbsp;Unit Investment Trust:
              <span class="yearright">Year:</span> </label>&nbsp;&nbsp;
            <kendo-numerictextbox [autoCorrect]="autoCorrect" [format]="'0'" [spinners]="false" formControlName="Uitexp"
              [min]="investmin" [max]="investmax" [value]="numValue">
            </kendo-numerictextbox>
            <span class="tiny" style="margin: 0px 20px 0px 15px">&nbsp;&nbsp;Exchange Trade Fund:</span>
            <span class="tiny" style="margin: 0px 10px 0px 0px">Year:</span>
            <kendo-numerictextbox [autoCorrect]="autoCorrect" [format]="'0'" [spinners]="false" formControlName="Etfexp"
              [min]="investmin" [max]="investmax" [value]="numValue">
            </kendo-numerictextbox>
          </div>
          <div class="spacing">
            <label class="tiny">
              &nbsp;Real Estate
              <span class="yearright">Year:</span> </label>&nbsp;&nbsp;
            <kendo-numerictextbox [autoCorrect]="autoCorrect" [format]="'0'" [spinners]="false"
              formControlName="RealEstateExp" [min]="investmin" [max]="investmax" [value]="numValue">
            </kendo-numerictextbox>
            <span class="tiny" style="margin: 0px 20px 0px 20px">Insurance:</span>
            <span class="tiny" style="margin: 0px 10px 0px 60px">Year:</span>
            <kendo-numerictextbox [autoCorrect]="autoCorrect" [spinners]="false" [format]="'0'" formControlName="InsExp"
              [min]="investmin" [max]="investmax" [value]="numValue">
            </kendo-numerictextbox>
          </div>
          <div class="spacing">
            <label class="tiny">
              &nbsp;Variable Annuities:
              <span class="yearright">Year:</span> </label>&nbsp;&nbsp;
            <kendo-numerictextbox [autoCorrect]="autoCorrect" [format]="'0'" [spinners]="false" formControlName="Vaexp"
              [min]="investmin" [max]="investmax" [value]="numValue">
            </kendo-numerictextbox>
            <span class="tiny" style="margin: 0px 20px 0px 20px">Fixed Annuities:</span>
            <span class="tiny" style="margin: 0px 10px 0px 32px">Year:</span>
            <kendo-numerictextbox [autoCorrect]="autoCorrect" [format]="'0'" [spinners]="false"
              formControlName="FixedAnnExp" [min]="investmin" [max]="investmax" [value]="numValue">
            </kendo-numerictextbox>
          </div>
          <div class="spacing">
            <label class="tiny">
              &nbsp;Precious Metals:<span class="yearright">Year:</span> </label>&nbsp;&nbsp;
            <kendo-numerictextbox [autoCorrect]="autoCorrect" [format]="'0'" [spinners]="false"
              formControlName="PrecMetExp" [min]="investmin" [max]="investmax" [value]="numValue">
            </kendo-numerictextbox>
            <span class="tiny" style="margin: 0px 20px 0px 20px">Commodities, Future:</span>
            <span class="tiny" style="margin: 0px 10px 0px 3px">Year:</span>
            <kendo-numerictextbox [autoCorrect]="autoCorrect" [format]="'0'" [spinners]="false"
              formControlName="CommExp" [min]="investmin" [max]="investmax" [value]="numValue">
            </kendo-numerictextbox>
          </div>
          <div class="spacing">
            <label class="tiny">
              &nbsp;Other:<span class="yearright">Year:</span> </label>&nbsp;&nbsp;
            <kendo-numerictextbox [autoCorrect]="autoCorrect" [format]="'0'" [spinners]="false"
              formControlName="OtherExp" [min]="investmin" [max]="investmax" [value]="numValue">
            </kendo-numerictextbox>
            <span class="tiny" style="margin: 0px 20px 0px 20px">Desc:</span>
            <span class="tiny" style="margin: 0px 10px 0px 112px"></span><input kendoTextBox type="text"
              style="width:130px" formControlName="OtherExpDesc" />
          </div>
        </div>
      </div>
      <div *ngIf="RoleAdvisor" class="card w-full lg:w-[48%]" [@simpleFadeAnimation]="'in'"
        style="height:auto !important;">
        <div class="card-header flex justify-between items-center">
          <h3 class="card-title"><i class="far fa-comments" style="color: green; font-size: 20px"></i>Add a Comment</h3>
        </div>
        <div class="p-2 space-y-2">
          <label class="tiny"> </label>&nbsp;
          <kendo-textarea placeholder="Comment" [rows]="3" resizable="vertical"
            formControlName="Comment"></kendo-textarea>
          <input type="text" formControlName="ClientNoteId" *ngIf="false" />
          <!-- <div class="spacing" *ngIf="Deletebuttonview">
            &nbsp;&nbsp;
            <span *ngIf="Roleperms">
              <button kendobutton type="button" (click)="onDelete()"
                *ngIf="profileForm.get('AccountOpen')?.value === true" style="float: right">
                Make InActive
              </button>
              <button kendobutton type="button" (click)="onOpen()"
                *ngIf="profileForm.get('AccountOpen')?.value === false" style="float: right">
                Make Active5
              </button>
            </span>
          </div> -->
        </div>
      </div>
    </div>
  </div>
  <div class="grid grid-cols-1 lg:grid-cols-2 gap-x-4 gap-y-[5px]" *ngIf="secondaryForm">
    <div class="card w-full">
      <div class="card-header flex justify-between items-center">
        <h3 class="card-title flex items-center">
          <kendo-checkbox #checkedState [formControl]="isSameAddressControl" (click)="pushCopyData()" *ngIf="Msecondary"
            [checkedState]="false"></kendo-checkbox>&nbsp;&nbsp;
          <span class="tiny">{{ secondaryheader }}</span>
        </h3>
        <span>{{ secondarymainheader }}</span>
      </div>
      <div class="p-6 space-y-3">
        <div *ngIf="hideclientreplist" class="mb-2">
          <label class="tiny">If a client exists simply select the client below:</label>
          <kendo-combobox #combo2 (selectionChange)="selectclientsecond($event)" [virtual]="virtual" [loading]="loader"
            style="width: 300px; margin-left: 8px; margin-bottom: 10px" [kendoDropDownFilter]="filterSettings"
            [valuePrimitive]="true" [data]="clientlisting" [textField]="'firstName'" [valueField]="'clientId'">
          </kendo-combobox>
        </div>

        <div class="flex items-center gap-2">
          <label class="tiny">First Name:</label>
          <input kendoTextBox type="text" #SecondaryFirstName formControlName="SecondaryFirstName" class="flex-1" />
        </div>
        <div class="flex items-center gap-2">
          <label class="tiny">Middle Name:</label>
          <input kendoTextBox type="text" #SecondaryMiddleName formControlName="SecondaryMiddleName" class="flex-1" />
        </div>
        <div class="flex items-center gap-2">
          <label class="tiny">Last Name:</label>
          <input kendoTextBox type="text" #SecondaryLastName formControlName="SecondaryLastName" class="flex-1" />
        </div>
         <div class="spacing" *ngIf="[2, 5, 6, 7, 8, 33].includes(profileForm.get('ClientTypeId')?.value)">
          <label class="tiny"><i class="fas fa-asterisk" [ngClass]="{
                      novalue: [2, 5, 6, 7, 8, 33].includes(profileForm.get('ClientTypeId')?.value) && !profileForm.get('SecondaryEmail')?.value,
                      havevalue: [1, 4].includes(profileForm.get('ClientTypeId')?.value) || profileForm.get('SecondaryEmail')?.value
                    }"></i>&nbsp; Email: </label>&nbsp;&nbsp;<input kendoTextBox type="email"
            formControlName="SecondaryEmail" [required]="[2, 5, 6, 7, 8, 33].includes(profileForm.get('ClientTypeId')?.value)" />
        </div>
        <div class="spacing" *ngIf="[2, 5, 6, 7, 8, 33].includes(profileForm.get('ClientTypeId')?.value)">
          <label class="tiny"> Mobile/Phone: </label>&nbsp;&nbsp;<kendo-maskedtextbox [mask]="mobileMask"
            formControlName="SecondaryMobile" [promptPlaceholder]="' '"></kendo-maskedtextbox>
        </div>
        <div class="flex items-center gap-2" *ngIf="RoleAdvisor">
          <label class="tiny">Tax ID:</label>
          <kendo-maskedtextbox #maskvalue2 [mask]="mask" [value]="value" formControlName="SecondaryTaxID"
            (focusout)="onSecondaryTaxIdBlur(maskvalue2)" class="flex-1">
          </kendo-maskedtextbox>
        </div>
        <!-- 529 beneficiary / UTMA-UGMA custodian: soft warning only, saving is still allowed -->
        <div *ngIf="RoleAdvisor && isSoftDupType() && secondaryDupMatches.length"
          class="rounded-md border border-warning bg-warning-light p-2 text-[11px] text-gray-800" role="status">
          <div class="font-semibold">&#9888; This {{ secondaryPartyLabel }} Tax ID is already on an existing 529 or UTMA/UGMA account. You can still save.</div>
          <ul class="mt-1 list-none pl-0">
            <li *ngFor="let m of secondaryDupMatches">
                <a class="text-primary underline cursor-pointer" (click)="openExistingAccount(m.clientID)"
                  title="Opens the existing account in a new tab">{{ m.accountName || (m.lastName + ', ' + m.firstName) }}</a>
                <span class="text-gray-600"> &middot; {{ accountTypeLabel(m.clientTypeId) }}<span *ngIf="m.taxID"> &middot; &bull;&bull;{{ m.taxID }}</span></span>
              </li>
          </ul>
        </div>
        <div class="flex items-center gap-2" *ngIf="RoleAdvisor">
          <label class="tiny">Date of Birth:</label>
          <kendo-datepicker class="secondaryDatepicker flex-1" [focusedDate]="focusedDOBDatesecond" #dp3
            (focus)="onFocus3(dp3)" formControlName="SecondaryDOB" #SecondaryDOB style="width: 200px"
            [disabledDates]="accountDateDisabledDates" (valueChange)="calculateSecondaryAge($event)">
          </kendo-datepicker>
          <label class="tiny ml-2">{{ calculatedSecondaryAge }}</label>
        </div>
        <div class="flex items-center gap-2" *ngIf="RoleAdvisor">
          <label class="tiny">Address 1:</label>
          <input #SecondaryAddress1 kendoTextBox type="text" formControlName="SecondaryAddress1" class="flex-1" />
        </div>
        <div class="flex items-center gap-2" *ngIf="RoleAdvisor">
          <label class="tiny">Address 2:</label>
          <input kendoTextBox type="text" formControlName="SecondaryAddress2" class="flex-1" />
        </div>
        <div class="flex items-center gap-2" *ngIf="RoleAdvisor">
          <label class="tiny">City:</label>
          <input #SecondaryCity kendoTextBox type="text" formControlName="SecondaryCity" class="flex-1" />
        </div>
        <div class="flex items-center gap-2" *ngIf="RoleAdvisor">
          <label class="tiny">State:</label>
          <kendo-dropdownlist #SecondaryState formControlName="SecondaryState"
            (selectionChange)="selectionStateChange2($event)" [virtual]="virtual" [loading]="loaderstatelist"
            [data]="listStates" [textField]="'stateText'" [valuePrimitive]="true" class="form-control flex-1"
            [valueField]="'stateValue'" style="width: 300px; height: 25px">
          </kendo-dropdownlist>
        </div>
        <div class="flex items-center gap-2" *ngIf="RoleAdvisor">
          <label class="tiny">ZipCode:</label>
          <kendo-maskedtextbox #zip2 #SecondaryZipCode formControlName="SecondaryZipCode" class="flex-1">
          </kendo-maskedtextbox>
        </div>
      </div>
    </div>
    <!-- Card 6 -->
    <div class="card w-full">
    </div>
  </div>
  <div style="padding: 20px">
   </div>
  <div class="card rounded-2xl shadow p-6 my-4 floating-action-container">
    <div *ngIf="profileForm.invalid" class="mb-3 p-3 bg-red-50 border border-red-300 rounded text-red-700 text-[11px]">
      <strong class="text-[12px]">Invalid fields:</strong>
      <ul class="list-disc ml-5 mt-1 space-y-0.5">
        <li *ngFor="let name of invalidControlNames">{{ name }}</li>
      </ul>
    </div>
    <button kendoButton themeColor="primary" *ngIf="!queryupdate" [disabled]="!profileForm.valid">
      Submit
    </button>
    <button kendoButton type="button" (click)="onUpdate()" [disabled]="
      !profileForm.valid || profileForm.get('AccountOpen')?.value === false
    " *ngIf="queryupdate">
      Update
    </button>
    <button kendoButton class="action-button" (click)="onDelete()" type="button" [disabled]="!profileForm.valid" *ngIf="
        Deletebuttonview &&
        Roleperms &&
        profileForm.get('AccountOpen')?.value === true
      ">
      Make Inactive
    </button>
     
    <button kendoButton class="action-button" (click)="onOpen()" type="button" [disabled]="!profileForm.valid" *ngIf="
        Deletebuttonview &&
        Roleperms &&
        profileForm.get('AccountOpen')?.value === false
      ">
      Make Active
    </button>
  </div>
</form>
<!--         animate="animates"-->
<kendo-dialog (close)="deleteAccountUserClosebybutton()" *ngIf="openDeleteAccount" [minWidth]="250" [width]="550">
  <kendo-dialog-titlebar>
    <div style="font-size: 18px; line-height: 1.3em">
      <span class="k-icon k-i-print"></span> Are you sure you want to make this
      account inactive?
    </div>
  </kendo-dialog-titlebar>
  <form [formGroup]="form">
    <label class="tinytime"> &nbsp;Please choose a reason: </label>
    <div class="card  rounded-2xl shadow p-6 my-4">
      <kendo-dropdownlist #drop formControlName="reasonselect" [textField]="'reasondescription'"
        [valueField]="'reasonId'" [valuePrimitive]="true" [virtual]="virtual" [data]="dataReasonlist"
        (valueChange)="selectedReasonId = $event" style="width: 100%">
      </kendo-dropdownlist>
    </div>
    <kendo-dialog-actions>
      <button kendoButton type="button" (click)="onSubmit(true, false)" style="width: 100%"
        [disabled]="form.get('reasonselect')?.value == null">
        Remove Account
      </button>
      <button kendoButton type="button" (click)="deleteAccountUserClosebybutton()" style="width: 100%">
        Close Window
      </button>
    </kendo-dialog-actions>
  </form>
</kendo-dialog>
<kendo-dialog (close)="closeDupDialog()" *ngIf="showDupDialog" [minWidth]="280" [width]="560">
  <kendo-dialog-titlebar>
    <div style="font-size: 18px; line-height: 1.3em">&#9888; Possible duplicate account</div>
  </kendo-dialog-titlebar>
  <div class="flex flex-col gap-3 text-sm">
    <p class="text-gray-700">
      We found existing accounts that match the Tax IDs on this form. Review them below, or save this
      account anyway.
    </p>
    <div *ngIf="primaryDupMatches.length">
      <div class="font-semibold text-gray-900">Same account owner / minor Tax ID</div>
      <ul class="mt-1 list-none pl-0">
        <li *ngFor="let m of primaryDupMatches">
                <a class="text-primary underline cursor-pointer" (click)="openExistingAccount(m.clientID)"
                  title="Opens the existing account in a new tab">{{ m.accountName || (m.lastName + ', ' + m.firstName) }}</a>
                <span class="text-gray-600"> &middot; {{ accountTypeLabel(m.clientTypeId) }}<span *ngIf="m.taxID"> &middot; &bull;&bull;{{ m.taxID }}</span></span>
              </li>
      </ul>
    </div>
    <div *ngIf="secondaryDupMatches.length">
      <div class="font-semibold text-gray-900">Same {{ secondaryPartyLabel }} Tax ID</div>
      <ul class="mt-1 list-none pl-0">
        <li *ngFor="let m of secondaryDupMatches">
                <a class="text-primary underline cursor-pointer" (click)="openExistingAccount(m.clientID)"
                  title="Opens the existing account in a new tab">{{ m.accountName || (m.lastName + ', ' + m.firstName) }}</a>
                <span class="text-gray-600"> &middot; {{ accountTypeLabel(m.clientTypeId) }}<span *ngIf="m.taxID"> &middot; &bull;&bull;{{ m.taxID }}</span></span>
              </li>
      </ul>
    </div>
  </div>
  <kendo-dialog-actions>
    <button kendoButton type="button" (click)="closeDupDialog()" style="width: 100%">Go back</button>
    <button kendoButton type="button" themeColor="primary" (click)="confirmSaveAnyway()" style="width: 100%">
      Save anyway
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
<kendo-dialog (close)="openAccountUserClosebybutton()" *ngIf="openOpenAccount" [minWidth]="250" [width]="550">
  <kendo-dialog-titlebar>
    <div style="font-size: 18px; line-height: 1.3em">
      <span class="k-icon k-i-print"></span> Are you sure you want this account
      active?
    </div>
  </kendo-dialog-titlebar>
  <form [formGroup]="form">
    <kendo-dialog-actions>
      <button kendoButton type="button" (click)="onSubmit(true, true)" style="width: 100%">
        Re-Open Account
      </button>
      <button kendoButton type="button" (click)="openAccountUserClosebybutton()" style="width: 100%">
        Never Mind!
      </button>
    </kendo-dialog-actions>
  </form>
</kendo-dialog>
<kendo-dialog (close)="closeTransactionPicker()" *ngIf="showTransactionPicker" [minWidth]="250" [width]="650">
  <kendo-dialog-titlebar>
    <div style="font-size: 18px; line-height: 1.3em">
      Which transaction's files do you want to see?
    </div>
  </kendo-dialog-titlebar>
  <div style="max-height: 400px; overflow-y: auto">
    <div class="inner-wrapper" *ngFor="let t of transactionFileList" style="padding: 4px 0">
      <a (click)="openTransactionFiles(t.blotterId)" routerLinkActive="router-link-active">
        <ng-icon name="heroFolder" style="font-size: 15px" title="View Files"></ng-icon>
        <span style="font-size: small; cursor: pointer">&nbsp;{{ t.label }}</span>
      </a>
    </div>
  </div>
  <kendo-dialog-actions>
    <button kendoButton type="button" (click)="closeTransactionPicker()" style="width: 100%">
      Close Window
    </button>
  </kendo-dialog-actions>
</kendo-dialog>